import { createAction, handleActions } from 'redux-actions'

const setOriginalItems = createAction('SCREENS/SUB_VALUATION/SET_ORIGINAL_ITEMS')
const resetOriginalItems = createAction('SCREENS/SUB_VALUATION/RESET_ORIGINAL_ITEMS')

const defaultState = []

const reducer = handleActions(
  {
    [setOriginalItems]: (state, { payload }) => payload,
    [resetOriginalItems]: () => defaultState,
  },
  defaultState,
)

export { setOriginalItems, resetOriginalItems, reducer }
